export default __webpack_public_path__ + "static/newsListSpotlightBanner-36a38d3484575181290f72b5af6474d1.png";